import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { FormInlineErrorComponent, SsnFieldComponent } from '@k12/forms';
import { HouseholdRecordVm } from '@k12/models';

const DATE_INPUT_FORMAT = 'MM/DD/YYYY';

export const CUSTOM_DATE_FORMATS = {
  parse: { dateInput: DATE_INPUT_FORMAT },
  display: {
    dateInput: DATE_INPUT_FORMAT,
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'lib-household-parent-info',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    SsnFieldComponent,
    FormInlineErrorComponent
  ],
  templateUrl: './household-parent-info.component.html',
  providers: [{ provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }]
})
export class HouseholdParentInfoComponent {
  @Input() formGroup!: FormGroup;
  @Input() householdData!: HouseholdRecordVm;

  get ssnControl(): FormControl<string | null> {
    return this.formGroup.get('ssn') as FormControl<string | null>;
  }
}
